module.exports = __webpack_public_path__ + "static/media/flag06.b77d89ed.svg";